// extracted by mini-css-extract-plugin
export var GridWrapper = "Grid-module--GridWrapper--1AuSi";
export var Bold = "Grid-module--Bold--2Ltme";
export var Thin = "Grid-module--Thin--RC6Fj";